import axios from "axios";
import { BASE_URL } from "../constants/App";

const headers = { 'Content-Type': 'application/json' };

export const axiosAPICall = axios.create({
  baseURL: BASE_URL,
  headers: headers
});